module.exports = __webpack_public_path__ + "img/badge_color_spe-transition.dbfe40b5.svg";